import React from 'react';
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import {handleLinkClick} from "../../../Utils/misc/openLink.ts";

interface OverdueFeesProps {}

const OverdueFees: React.FC<OverdueFeesProps> = () => {
    const userObj = useAppStore((state: any) => state.userObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;

    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div className="bg-neutral-200 dark:bg-neutral-800 rounded-xl shadow-2xl w-[98%] sm:w-3/4 max-w-2xl overflow-hidden border-2 border-neutral-700">
                <div className="p-8">
                    <div className="mb-8">
                        <h2 className="text-3xl font-bold dark:text-white mb-4 text-center">⚠️ Overdue Fees ⚠️</h2>
                        <p className="text-xl dark:text-neutral-200 text-center leading-relaxed">
                            You owe <span className="text-red-500 font-bold">${Math.abs(userObj.remainingBalance).toFixed(2)}</span> in overdue fees.<br/>
                            Please pay <a href="https://www.onuro.ai/manage-account" target="_blank" rel="noopener noreferrer" className="text-cyan-500 hover:text-cyan-600 underline font-semibold" onClick={(e) => handleLinkClick(e, environment, vscode, "https://www.onuro.ai/manage-account")}>here</a> and refresh the application.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverdueFees;